var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6673333,1.33333333 L4.66733333,1.33333333 C3.932,1.33333333 3.334,1.93066667 3.334,2.66666667 L3.334,3.33333333 L4.66733333,3.33333333 L4.66733333,4 L2.00066667,4 L2.00066667,5.33333333 L3.334,5.33333333 L3.334,6.66666667 L4.66733333,6.66666667 L4.66733333,7.33333333 L2.00066667,7.33333333 L2.00066667,8.66666667 L3.334,8.66666667 L3.334,10 L4.66733333,10 L4.66733333,10.6666667 L2.00066667,10.6666667 L2.00066667,12 L3.334,12 L3.334,13.3333333 C3.334,14.068 3.932,14.6666667 4.66733333,14.6666667 L12.6673333,14.6666667 C13.4026667,14.6666667 14.0006667,14.068 14.0006667,13.3333333 L14.0006667,2.66666667 C14.0006667,1.93066667 13.4026667,1.33333333 12.6673333,1.33333333 Z M8.66733333,5.33266667 C9.40333333,5.33266667 10.0006667,5.93 10.0006667,6.666 C10.0006667,7.402 9.40333333,7.99933333 8.66733333,7.99933333 C7.93133333,7.99933333 7.334,7.402 7.334,6.666 C7.334,5.93 7.93066667,5.33266667 8.66733333,5.33266667 L8.66733333,5.33266667 Z M6.66733333,10.6666667 C6.66733333,9.43933333 7.44,8.66666667 8.66733333,8.66666667 C9.89466667,8.66666667 10.6673333,9.43933333 10.6673333,10.6666667 L6.66733333,10.6666667 Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.7952a6ada031446ff075abbe9d6f39c1.svg";
export { ForwardRef as ReactComponent };